import _ from 'lodash';
(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("footerSettings", {
        templateUrl: "app/settings/theme/footer/footerSettings.component.html",
        controller: ["tenantResource", "frameworkService", "messageService", "$localStorage", "$rootScope", FooterSettingsCtrl],
        controllerAs: "vm"
    });
    function FooterSettingsCtrl(tenantResource, frameworkService, messageService, $localStorage, $rootScope) {
        var vm = this;
        vm.saving = false;
        vm.loading = true;
        vm.enabledLocalizations = frameworkService.data.tenant.enabledLocalizations;
        vm.selectedLocalizationId = parseInt($localStorage.currentLocalizationId);
        vm.samples = [
            {
                id: 1,
                name: "settings.theme.footer.sampleAaboutUs",
                text: "<h4 class='footer-header'>About Us</h4>\r<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.Sed nec tristique dolor, ac efficitur velit.Nulla lobortis tempus convallis.Nulla aliquam lectus eu porta pulvinar.Mauris semper justo erat.</p>"
            },
            {
                id: 2,
                name: "settings.theme.footer.sampleResources",
                text: "<h4 class='footer-header'>Resources</h4>\r" +
                    "<ul class='list-group borderless noBullets'>\r" +
                    "  <li><a href='https://google.com'>Google.com</a></li>\r" +
                    "  <li><a href='https://google.com'>Google.com</a></li>\r" +
                    "  <li><a href='https://google.com'>Google.com</a></li>\r" +
                    "</ul>"
            },
            {
                id: 3,
                name: "settings.theme.footer.sampleFollowUs",
                text: "<h4 class='footer-header'>Follow Us</h4>\r" +
                    "<p>\r" +
                    "  <a href='https://twitter.com/youraccount'><i class='p-5 fa fa-2x fa-twitter'></i></a>\r" +
                    "  <a href='https://facebook.com/youraccount'><i class='p-5 fa fa-2x fa-facebook-official'></i></a>\r" +
                    "  <a href='https://linkedin.com/in/youraccount'><i class='p-5 fa fa-2x fa-linkedin'></i></a>\r" +
                    "</p>"
            }
        ];
        vm.changeLanguage = changeLanguage;
        vm.loadLeftSample = loadLeftSample;
        vm.loadRightSample = loadRightSample;
        vm.save = save;
        vm.$onInit = function () {
            load();
        };
        ////////////////////////////////////////////
        function load() {
            tenantResource.getFooterSettings(function (result) {
                vm.model = result;
                vm.loading = false;
            });
        }
        function changeLanguage(localizationId) {
            vm.selectedLocalizationId = localizationId;
        }
        function loadLeftSample() {
            var sample = _.find(vm.samples, { id: vm.sampleLeft });
            var footer = _.find(vm.model.footers, { localizationId: vm.selectedLocalizationId });
            footer.footerLeft = sample.text;
        }
        function loadRightSample() {
            var sample = _.find(vm.samples, { id: vm.sampleRight });
            var footer = _.find(vm.model.footers, { localizationId: vm.selectedLocalizationId });
            footer.footerRight = sample.text;
        }
        function save() {
            vm.saving = true;
            tenantResource.saveFooterSettings(vm.model, function () {
                messageService.success("common.changesSaved");
                vm.saving = false;
                $rootScope.$broadcast("reloadTenantSettings");
            }, function () {
                messageService.error("common.genericError");
                vm.saving = false;
            });
        }
    }
}());
